var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 166,
    width: 321,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 35,
    stroke: "#A31F34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.5,0v166m57-166v113m57-113v166m57-166v33m58,20v113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.5,53v113",
    stroke: "#8A8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229,16.5h92",
    strokeWidth: 33
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMitLogo);
export default __webpack_public_path__ + "static/media/MIT_logo.40296cf558616a8ff9d2c39616775387.svg";
export { ForwardRef as ReactComponent };